'use client';

import { ReactNode } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { InitSessionState } from '@users/session/serverSide/InitSessionState';
import { TYPES } from '@framework/config/DI/types';
import { TNonce } from '@framework/router/Next/headers/ContentSecurityPolicyHeader';
import { IGlobalProps } from '@/dataroom/app/server/rootLayout/getGlobalProps';

interface IProps {
  children: ReactNode,
  session: IGlobalProps['session'],
  nonce: TNonce,
}

const ClientBindings = ({ children, session, nonce }: IProps): ReactNode => {
  const container = getContainer();
  container.bindContextValue(InitSessionState, session, true);

  if (!container.isBound(TYPES.Nonce)) {
    container.bind<TNonce>(TYPES.Nonce).toConstantValue(nonce);
  }

  return children;
};

export default ClientBindings;
